import * as constants from './constants';
import controller from './controller';

const dispatchFail = (dispatch, failType, error) => {
  dispatch({ type: failType, payload: { loading: false, error } });

  throw error;
};

export function resetError() {
  return { type: constants.RESET_ERROR, payload: { error: null } };
}

export function getCarmenMakes() {
  return dispatch => controller.getCarmenMakes().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.GET_CARMEN_VEHICLE_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.GET_CARMEN_VEHICLE_SUCCESS,
      payload: { carmenMakes: response.data, loading: false, error: undefined },
    });
  });
}

export const updateCarmenMake = (id, data) => {
  return dispatch => controller.updateCarmenMake(id, data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_CARMEN_VEHICLE_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.UPDATE_CARMEN_VEHICLE_SUCCESS,
      payload: { error: undefined },
    });
  });
};

export function getCarmenUsers() {
  return dispatch => controller.getCarmenUsers().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.GET_CARMEN_USERS_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.GET_CARMEN_USERS_SUCCESS,
      payload: { carmenUsers: response.data, loading: false, error: undefined },
    });
  });
}

export const updateCarmenUser = data => {
  return dispatch => controller.updateCarmenUser(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_CARMEN_USER_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.UPDATE_CARMEN_USER_SUCCESS,
      payload: { error: undefined },
    });
  });
};
